<template>
  <v-container fluid :style="{ width: '100%', height: dynamicHeight }">
    <v-card>
      <v-card-title>
        <span class="text-h5">静配生物安全柜管理</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="openCreateDialog" small>
          <v-icon left>mdi-plus</v-icon>
          新增记录
        </v-btn>
      </v-card-title>

      <!-- 搜索区域 -->
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="searchForm.hospitalName"
              label="医院名称"
              clearable
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="searchForm.deviceType"
              label="设备类型"
              clearable
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="searchForm.manufacturer"
              label="厂家名称"
              clearable
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-btn color="primary" @click="searchData" class="mr-2" small>
              <v-icon left>mdi-magnify</v-icon>
              搜索
            </v-btn>
            <v-btn @click="resetSearch" small>
              <v-icon left>mdi-refresh</v-icon>
              重置
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- 数据表格 -->
      <v-data-table
        :headers="headers"
        :items="tableData"
        :loading="loading"
        :server-items-length="total"
        :options.sync="options"
        class="elevation-1"
        @update:options="loadData"
      >
        <template v-slot:item.actions="{ item }">
          <div class="d-flex align-center" style="gap: 4px;">
            <v-btn 
              small 
              rounded 
              color="#FF9800" 
              style="color: white; min-width: 32px; height: 28px; padding: 0 8px;"
              @click="editItem(item)"
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn 
              small 
              rounded 
              color="#F44336" 
              style="color: white; min-width: 32px; height: 28px; padding: 0 8px;"
              @click="deleteItemHandle(item)"
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- 新增/编辑对话框 -->
    <v-dialog v-model="dialog" max-width="800px" persistent>
      <v-card>
        <v-card-title class="primary white--text">
          <span class="text-h6">{{ isEdit ? '编辑' : '新增' }}静配生物安全柜</span>
        </v-card-title>

        <v-card-text class="mt-4 pt-2">
          <v-form ref="form" v-model="valid">
            <v-row>
              <v-col cols="12" md="6">
                <v-combobox
                  v-model="formData.hospitalName"
                  :items="hospitalsList"
                  item-text="name"
                  item-value="name"
                  label="医院"
                  dense
                  clearable
                  :loading="hospitalsLoading"
                  @change="onHospitalChange"
                  placeholder="请选择或输入医院名称"
                ></v-combobox>
              </v-col>
              
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.deviceType"
                  label="设备类型" clearable
                  dense
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.manufacturer"
                  label="厂家名称" clearable
                  dense
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.model"
                  label="型号" clearable
                  dense
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-row no-gutters>
                  <v-col cols="12">
                    <label class="v-label theme--light" style="font-size: 12px; color: rgba(0,0,0,0.6); margin-bottom: 4px; display: block;">外形尺寸（宽*深*高）单位：mm</label>
                  </v-col>
                  <v-col cols="4" class="pr-1">
                    <v-text-field
                      v-model="formData.externalWidth"
                      placeholder="宽"
                      dense
                      type="number"
                      hide-details
                      outlined
                      style="font-size: 12px;"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="px-1">
                    <v-text-field
                      v-model="formData.externalDepth"
                      placeholder="深"
                      dense
                      type="number"
                      hide-details
                      outlined
                      style="font-size: 12px;"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="pl-1">
                    <v-text-field
                      v-model="formData.externalHeight"
                      placeholder="高"
                      dense
                      type="number"
                      hide-details
                      outlined
                      style="font-size: 12px;"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6">
                <v-row no-gutters>
                  <v-col cols="12">
                    <label class="v-label theme--light" style="font-size: 12px; color: rgba(0,0,0,0.6); margin-bottom: 4px; display: block;">工作区域尺寸（宽*深*高）单位：mm</label>
                  </v-col>
                  <v-col cols="4" class="pr-1">
                    <v-text-field
                      v-model="formData.workAreaWidth"
                      placeholder="宽"
                      dense
                      type="number"
                      hide-details
                      outlined
                      style="font-size: 12px;"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="px-1">
                    <v-text-field
                      v-model="formData.workAreaDepth"
                      placeholder="深"
                      dense
                      type="number"
                      hide-details
                      outlined
                      style="font-size: 12px;"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="pl-1">
                    <v-text-field
                      v-model="formData.workAreaHeight"
                      placeholder="高"
                      dense
                      type="number"
                      hide-details
                      outlined
                      style="font-size: 12px;"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.frontWindowMaxHeight"
                  label="前窗开启最大高度（单位：mm）"
                  clearable
                  dense
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.desktopToFloorHeight"
                  label="台面到地面高度（单位：mm）"
                  clearable
                  dense
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="formData.remark"
                  label="备注"
                  clearable outlined
                  dense
                  rows="3"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="grey lighten-2">
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog">取消</v-btn>
          <v-btn color="primary" :disabled="!valid" @click="saveData">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 删除确认对话框 -->
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title class="text-h6">确认删除</v-card-title>
        <v-card-text>确定要删除这条记录吗？此操作不可恢复。</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">取消</v-btn>
          <v-btn color="error" @click="confirmDelete">删除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Toast 消息提示组件 -->
    <BcToast ref="toast"></BcToast>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import BcToast from '@/plugins/Toast.vue'

export default {
  name: 'BiosafetyCabinet',
  components: {
    BcToast
  },
  data() {
    return {
      loading: false,
      dialog: false,
      deleteDialog: false,
      isEdit: false,
      valid: false,
      tableData: [],
      total: 0,
      options: {
        page: 1,
        itemsPerPage: 10
      },
      searchForm: {
        hospitalName: '',
        deviceType: '',
        manufacturer: ''
      },
      formData: {
        hospitalId: null,
        hospitalName: '',
        deviceType: '',
        manufacturer: '',
        model: '',
        externalDimensions: '',
        workAreaDimensions: '',
        // 外形尺寸分离字段
        externalWidth: null,
        externalDepth: null,
        externalHeight: null,
        // 工作区域尺寸分离字段
        workAreaWidth: null,
        workAreaDepth: null,
        workAreaHeight: null,
        frontWindowMaxHeight: null,
        desktopToFloorHeight: null,
        remark: ''
      },
      deleteItem: null,
      headers: [
        { text: '医院名称', value: 'hospital.name', sortable: false },
        { text: '设备类型', value: 'deviceType', sortable: false },
        { text: '厂家名称', value: 'manufacturer', sortable: false },
        { text: '型号', value: 'model', sortable: false },
        { text: '外形尺寸', value: 'externalDimensions', sortable: false },
        { text: '工作区域尺寸', value: 'workAreaDimensions', sortable: false },
        { text: '前窗最大高度', value: 'frontWindowMaxHeight', sortable: false },
        { text: '台面到地面高度', value: 'desktopToFloorHeight', sortable: false },
        { text: '创建时间', value: 'createdAt', sortable: false },
        { text: '操作', value: 'actions', sortable: false, width: '120' }
      ],
      rules: {
        required: value => !!value || '此字段为必填项'
      }
    }
  },

  computed: {
    ...mapGetters(['hospitalsList', 'hospitalsLoading']),
    dynamicHeight() {
      return 'calc(100vh - 64px)'
    }
  },

  mounted() {
    this.fetchHospitals()
    this.loadData()
  },

  methods: {
    ...mapActions(['fetchHospitals']),
    async loadData() {
      this.loading = true
      try {
        const params = {
          page: this.options.page,
          limit: this.options.itemsPerPage,
          ...this.searchForm
        }

        const response = await axios.get('/api/device/biosafety-cabinet/list', { params })

        if (response.data.code === 200) {
          this.tableData = response.data.data.rows
          this.total = response.data.data.total
        } else {
          this.$refs.toast.error(response.data.message || '获取数据失败')
        }
      } catch (error) {
        console.error('获取数据失败:', error)
        this.$refs.toast.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },



    searchData() {
      this.options.page = 1
      this.loadData()
    },

    resetSearch() {
      this.searchForm = {
        hospitalName: '',
        deviceType: '',
        manufacturer: ''
      }
      this.searchData()
    },

    openCreateDialog() {
      this.isEdit = false
      this.formData = {
        hospitalId: null,
        hospitalName: '',
        deviceType: '',
        manufacturer: '',
        model: '',
        externalDimensions: '',
        workAreaDimensions: '',
        // 外形尺寸分离字段
        externalWidth: null,
        externalDepth: null,
        externalHeight: null,
        // 工作区域尺寸分离字段
        workAreaWidth: null,
        workAreaDepth: null,
        workAreaHeight: null,
        frontWindowMaxHeight: null,
        desktopToFloorHeight: null,
        remark: ''
      }
      this.dialog = true
    },

    viewItem(item) {
      // 查看功能，可以显示详细信息或跳转到详情页
      console.log('查看项目:', item)
      // 这里可以根据需要实现查看逻辑，比如打开详情对话框或跳转页面
      this.$refs.toast.info('查看功能待实现')
    },

    editItem(item) {
      this.isEdit = true
      this.formData = { ...item }
      // 设置医院名称用于编辑
      if (item.hospital && item.hospital.name) {
        this.formData.hospitalName = item.hospital.name
        this.formData.hospitalId = item.hospital.id
      }

      // 拆分外形尺寸数据
      const externalDims = this.splitDimensions(item.externalDimensions)
      this.formData.externalWidth = externalDims.width
      this.formData.externalDepth = externalDims.depth
      this.formData.externalHeight = externalDims.height

      // 拆分工作区域尺寸数据
      const workAreaDims = this.splitDimensions(item.workAreaDimensions)
      this.formData.workAreaWidth = workAreaDims.width
      this.formData.workAreaDepth = workAreaDims.depth
      this.formData.workAreaHeight = workAreaDims.height

      this.dialog = true
    },

    deleteItemHandle(item) {
      this.deleteItem = item
      this.deleteDialog = true
    },

    async confirmDelete() {
      try {
        const response = await axios.delete(`/api/device/biosafety-cabinet/delete/${this.deleteItem.id}`)

        if (response.data.code === 200) {
          this.$refs.toast.success('删除成功')
          this.loadData()
        } else {
          this.$refs.toast.error(response.data.message || '删除失败')
        }
      } catch (error) {
        console.error('删除失败:', error)
        this.$refs.toast.error('删除失败')
      } finally {
        this.deleteDialog = false
        this.deleteItem = null
      }
    },

    // 组合尺寸数据
    combineDimensions(width, depth, height) {
      if (width && depth && height) {
        return `${width}*${depth}*${height}`
      }
      return ''
    },

    // 拆分尺寸数据
    splitDimensions(dimensionString) {
      if (dimensionString && typeof dimensionString === 'string') {
        const parts = dimensionString.split('*')
        if (parts.length === 3) {
          return {
            width: parseInt(parts[0]) || null,
            depth: parseInt(parts[1]) || null,
            height: parseInt(parts[2]) || null
          }
        }
      }
      return { width: null, depth: null, height: null }
    },

    async saveData() {
      if (!this.$refs.form.validate()) {
        return
      }

      try {
        // 确保hospitalName是字符串格式
        const submitData = { ...this.formData }
        if (typeof submitData.hospitalName === 'object' && submitData.hospitalName && submitData.hospitalName.name) {
          const hospitalObj = submitData.hospitalName
          submitData.hospitalName = hospitalObj.name
          submitData.hospitalId = hospitalObj.id
        }

        // 组合尺寸数据
        submitData.externalDimensions = this.combineDimensions(
          submitData.externalWidth,
          submitData.externalDepth,
          submitData.externalHeight
        )
        submitData.workAreaDimensions = this.combineDimensions(
          submitData.workAreaWidth,
          submitData.workAreaDepth,
          submitData.workAreaHeight
        )

        // 移除分离的尺寸字段，避免发送到后端
        delete submitData.externalWidth
        delete submitData.externalDepth
        delete submitData.externalHeight
        delete submitData.workAreaWidth
        delete submitData.workAreaDepth
        delete submitData.workAreaHeight

        let response
        if (this.isEdit) {
          response = await axios.put(`/api/device/biosafety-cabinet/update/${this.formData.id}`, submitData)
        } else {
          response = await axios.post('/api/device/biosafety-cabinet/create', submitData)
        }

        if (response.data.code === 200) {
          this.$refs.toast.success(this.isEdit ? '更新成功' : '创建成功')
          this.closeDialog()
          this.loadData()
        } else {
          this.$refs.toast.error(response.data.message || '保存失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
        this.$refs.toast.error('保存失败')
      }
    },

    closeDialog() {
      this.dialog = false
      this.$refs.form.resetValidation()
    },

    onHospitalChange(hospitalName) {
      // 如果选择的是列表中的医院对象，提取名称
      if (typeof hospitalName === 'object' && hospitalName && hospitalName.name) {
        this.formData.hospitalName = hospitalName.name
        this.formData.hospitalId = hospitalName.id
      } else {
        // 如果是手动输入的字符串，直接使用
        this.formData.hospitalName = hospitalName
        this.formData.hospitalId = null
      }
    }
  }
}
</script>

<style scoped>
.v-data-table {
  font-size: 14px;
}
</style>
